import { ListJobsEntity } from "@shared/services/jobs/listJobs";

export let cantModifyWhenJobStatusAreTheseTypes = (status:ListJobsEntity["status"])=>{
  return ["IN_PROGRESS"].includes(status)
}
